import React from 'react';
import styled from "@emotion/styled";
import { colors } from 'src/theme';
import { i18n } from 'src/common';
import { Flex, Text } from 'src/components';
import { Card } from './card';

const CardStyle = styled(Card)({
  borderWidth: 1,
  borderStyle: 'dashed',
  borderColor: colors.border3,

  '&:hover': {
    borderColor: colors.primary
  }
})

const LinkStyle = styled.a({
  textDecoration: 'none',
  color: colors.primary,
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: 700,

  '&:hover': {
    color: '#8E00CC'
  }
})

export interface RequestAgent2CardProps {
  title?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
}

export const RequestAgent2Card: React.FC<RequestAgent2CardProps> = ({
  title = i18n.t('components.cards.requestAgentCard.title'),
  buttonLabel = i18n.t('components.cards.requestAgentCard.buttonLabel'),
  onButtonClick = () => console.log('click')
}) => (
  <CardStyle radius={12} padding={16} background='transparent'>
    <Flex gap={8}>
      <Text type='base'>{title}</Text>
      <LinkStyle href='#' onClick={(e) => {e.preventDefault(); onButtonClick();}}>
        {buttonLabel}
      </LinkStyle>
    </Flex>
  </CardStyle>
);
